import React from 'react';
import AppRouter from './Router';
import './App.css';
import { appVersion } from "./services/constants";

const App = () => {
  console.log({appVersion});
  return <AppRouter />;
};

export default App;
